import { FC } from "react";
import { SkeletonText } from "shared/components/Spor";

type SkeletonTextSingleProps = {};

export const SkeletonTextSingle: FC<SkeletonTextSingleProps> = () => (
  <SkeletonText
    height="15px"
    width="60px"
    noOfLines={1}
    _last={{ maxW: "100%" }} // Why put `maxW` in `_last` Spor?
  />
);
